import * as yup from "yup";

// The payment model is fixed once a brand has picked it, so it is not part of
// this form — Ops edits the settings that hang off it. `$isSelfPayout` comes in
// through the form's resolver context: only a managed-payout brand has debit
// notes, so only it needs a frequency.
export const paymentSetupSchema = yup.object({
    debit_note_frequency: yup.string().when("$isSelfPayout", {
        is       : true,
        then     : (s) => s.notRequired(),
        otherwise: (s) => s.required("Debit note frequency is required")
    }),
    payment_setup_status: yup.string().required("Setup status is required"),
    kyc_window          : yup
        .number()
        .typeError("KYC window must be a number")
        .integer("KYC window must be a whole number of days")
        .positive("KYC window must be greater than 0")
        .required("KYC window is required")
});

// `brand` is null until the overview fetch lands (the form is built on first
// render), so a default parameter isn't enough — it only covers undefined.
export const toPaymentSetupValues = (brand) => ({
    debit_note_frequency: brand?.debit_note_frequency || "",
    payment_setup_status: brand?.payment_setup_status || "",
    kyc_window          : brand?.kyc_window ?? ""
});

// The endpoint only changes the fields it is sent, so the body carries just what
// was edited.
export const toPaymentSetupPayload = (values, dirtyFields, isSelfPayout) => {
    const payload = {};
    if (dirtyFields.debit_note_frequency && !isSelfPayout) payload.debit_note_frequency = values.debit_note_frequency;
    if (dirtyFields.payment_setup_status) payload.payment_setup_status = values.payment_setup_status;
    if (dirtyFields.kyc_window) payload.kyc_window = Number(values.kyc_window);
    return payload;
};
